import React from "react";
import {
  Box,
  Card,
  CardContent,
  Chip,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import {
  BugReport,
  CheckCircle,
  NewReleases,
  Tune,
} from "@mui/icons-material";
import "./ReleaseLogPage.css";

const versionHistory = [
  {
    version: "26.06.16",
    releaseDate: "2026-06-16",
    features: [
      "Thêm giao diện Portal làm trang truy cập vào các ứng dụng.",
    ],
    bugFixes: [],
    improvements: [],
  },
  {
    version: "26.05.26",
    releaseDate: "2026-05-26",
    features: [
      "Tính năng export và import hạng mục hợp đồng",
      "Tính năng quản lý danh mục tài liệu",],
    bugFixes: [],
    improvements: [
      "Bổ sung thông tin phiên bản phát hành trên khu vực thông tin người dùng",
      "Bổ sung trang Nhật ký phát hành trong Quản trị hệ thống",
      "Cải thiện giao diện bảng hạng mục hợp đồng",
    ],
  },
];

function VersionSection({ title, icon, color, items }) {
  if (!items.length) {
    return null;
  }

  return (
    <Box sx={{ mb: 2 }}>
      <Typography
        variant="subtitle2"
        sx={{
          fontWeight: 700,
          display: "flex",
          alignItems: "center",
          gap: 1,
          color,
          mb: 1,
        }}
      >
        {icon}
        {title}
      </Typography>
      <List sx={{ py: 0, pl: 2 }}>
        {items.map((item, index) => (
          <ListItem key={index} sx={{ py: 0.5, px: 0 }}>
            <ListItemIcon sx={{ minWidth: 28 }}>
              <CheckCircle sx={{ fontSize: 16, color }} />
            </ListItemIcon>
            <ListItemText
              primary={item}
              primaryTypographyProps={{
                variant: "body2",
                sx: { fontSize: "0.9rem" },
              }}
            />
          </ListItem>
        ))}
      </List>
    </Box>
  );
}

export default function ReleaseLogPage() {
  return (
    <Box className="release-log-page" sx={{ p: 3 }}>
      <Box sx={{ mb: 3 }}>
        {/* <Typography variant="h5" fontWeight={700} gutterBottom>
          Nhật ký phát hành
        </Typography> */}
        <Typography variant="body2" fontWeight={700} gutterBottom>
          Thông tin cập nhật và nâng cấp các phiên bản phát hành của hệ thống
        </Typography>
      </Box>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            md: "repeat(2, minmax(0, 1fr))",
            lg: "repeat(3, minmax(0, 1fr))",
          },
          gap: 3,
        }}
      >
        {versionHistory.map((item, index) => (
          <Card
            key={`${item.version}-${item.releaseDate}`}
            className={`release-log-card${index === 0 ? " release-log-card--latest" : ""
              }`}
            sx={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              borderRadius: 2,
            }}
          >
            <CardContent sx={{ flex: 1 }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
                <Typography variant="h6" sx={{ fontWeight: 700, color: "#219ebc" }}>
                  {item.version}
                </Typography>
                {index === 0 && (
                  <Chip
                    label="Mới nhất"
                    color="primary"
                    size="small"
                    sx={{ backgroundColor: "#219ebc" }}
                  />
                )}
              </Box>

              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ display: "block", mb: 2 }}
              >
                Ngày phát hành: {item.releaseDate}
              </Typography>

              <Divider sx={{ mb: 2 }} />

              <VersionSection
                title="Tính năng mới"
                icon={<NewReleases fontSize="small" />}
                color="#2e7d32"
                items={item.features}
              />
              <VersionSection
                title="Sửa lỗi"
                icon={<BugReport fontSize="small" />}
                color="#d32f2f"
                items={item.bugFixes}
              />
              <VersionSection
                title="Cải thiện"
                icon={<Tune fontSize="small" />}
                color="#1976d2"
                items={item.improvements}
              />
            </CardContent>
          </Card>
        ))}
      </Box>
    </Box>
  );
}
